if (!customElements.get('tab-content')) {
  class TabContent extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
      this.handleEditorBlockSelectRef = this.handleEditorBlockSelect.bind(this);
    }

    handleToggle(event) {
      if (event.detail.id != this.getAttribute('data-id')) return;

      this.querySelectorAll('.js-tab').forEach((tab) => {
        tab.classList.toggle(
          'is-open',
          event.detail.index == tab.getAttribute('data-index'),
        );
      });
    }

    handleEditorBlockSelect(event) {
      const detail = {
        id: this.getAttribute('data-id'),
        index: event.target.getAttribute('data-index'),
      };

      document.dispatchEvent(
        new CustomEvent('exo:update-tab-head', { detail }),
      );
    }

    disconnectedCallback() {
      document.removeEventListener('exo:toggle-tab', this.handleToggleRef);
      this.removeEventListener(
        'shopify:block:select',
        this.handleEditorBlockSelectRef,
      );
    }

    connectedCallback() {
      document.addEventListener('exo:toggle-tab', this.handleToggleRef);
      this.addEventListener(
        'shopify:block:select',
        this.handleEditorBlockSelectRef,
      );
    }
  }

  customElements.define('tab-content', TabContent);
}
